import React, { useState } from "react";
import {
    FormControl,
    FormHelperText,
    Input,
} from "@chakra-ui/react";
import { FormControlEvo } from "../FormControlEvo";
import { FormLabelEvo } from "../label/FormLabelEvo";

export const EmailInputEvo = (props: any) => {
    const [email, setEmail] = useState(props.defaultVal || '');
    const [isTouched, setIsTouched] = useState(false);

    // Validate email format
    const isValidEmail = (email: string) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        return emailRegex.test(email);
    };

    // Handle input changes (manual and autocomplete)
    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setIsTouched(true);
        props.handleChange(e);

    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Set touched state on key down
        setIsTouched(true);
        props.handleChange(e);
    };

    const isError = isTouched && !isValidEmail(email);

    return (
        <FormControlEvo>
            <FormLabelEvo mandatory={true}>{"E-mail"}</FormLabelEvo>
            <Input
                placeholder={"Váš e-mail"}
                defaultValue={props.defaultVal}
                type={"email"}
                name={"email"}
                autoComplete={"email"} // Ensures browser autocomplete works
                isInvalid={isError}
                onKeyDown={handleKeyDown}
                onInput={handleInput} // Handles both typing and autocomplete
            />
            {isError ? (
                <FormHelperText color={"red"}>
                    Zadaná e-mailová adresa není ve správném formátu
                </FormHelperText>
            ) : <></>}
        </FormControlEvo>
    );
};